/**
 * Human-readable label for a brewery group member (name + optional city).
 * @param {{ name?: string, city?: string }} member
 * @returns {string}
 */
export function formatBreweryMemberLabel(member) {
  const name = member?.name || 'Unnamed location';
  const city = member?.city ? ` — ${member.city}` : '';
  return `${name}${city}`;
}
